//src/app/services/messages/createConversation.ts
import { IMessage } from '.';
import api from '..';

interface ICreateConversation {
  conversation_title: string;
  recipient_ids: number[];
  document_ids: number[];
  content: string;
  raw_content: string;
}

const e = api.injectEndpoints({
  endpoints: (builder) => ({
    createConversation: builder.mutation({
      query(args: ICreateConversation) {
        const {
          conversation_title,
          recipient_ids,
          document_ids,
          content,
          raw_content,
        } = args;
        return {
          url: `/messages`,
          method: 'POST',
          body: {
            message: {
              content,
              raw_content,
              recipient_ids,
              document_ids,
            },
            conversation_title,
          },
        };
      },
      transformResponse: (res: { message: IMessage }) => res.message,
    }),
  }),
});

export const { useCreateConversationMutation } = e;
